import React, { Component, Fragment, useState, useEffect } from "react";

import { compose } from "recompose";
import "views/Pma/PmaEditor/TableQuadrants/table-quadrants-editor.scss";
import { withSnackbar } from "notistack";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditQuadrantModal = (props) => {
  const {
    oldQuadrantData,
    handleInputChange,
    editQuadrantFormData,
    onCloseFn,
    modalType,
    areaID,
    onEditFormSubmit,
    selectedQuadrantNumber,
    handleRestoreDefault,
    titleEdit,
    maxMainTitleLength,
    maxMainSubtitleLength,
    mlsAreas,
    savingMessageShowing,
  } = props;
  // const { }

  if (!editQuadrantFormData.afAreaSubTitle) {
    editQuadrantFormData.afAreaSubTitle = "-";
  }
  if (titleEdit) {
    const { afAreaTitle, afAreaSubTitle } = editQuadrantFormData;

    let overMaxMainTitleLength =
      afAreaTitle &&
      afAreaTitle.length &&
      afAreaTitle.length >= maxMainTitleLength;
    let overMaxMainSubtitleLength =
      afAreaSubTitle &&
      afAreaSubTitle.length &&
      afAreaSubTitle.length >= maxMainSubtitleLength;
    return (
      <Fragment>
        <div className="edit-quadrant-container">
          <div className="edit-quadrant-form new-props">
            <div className="edit-quadrant-form-title-container">
              <p className="edit-quadrant-form-title-text">
                You Can Make Changes to the Title and Subtitle Here
              </p>
            </div>

            <div className="edit-quadrant-form-body">
              <div className="edit-form-body-col">
                <div className="edit-form-thead">
                  <div>
                    <p>Title </p>
                  </div>
                </div>
                <div className="edit-form-input main-title-input">
                  <div className="address-input-col">
                    <input
                      type="text"
                      id={`main-title`}
                      name={`afAreaTitle`}
                      className="title-input"
                      value={afAreaTitle || ""}
                      onChange={handleInputChange}
                      placeholder={afAreaTitle}
                      maxLength={maxMainTitleLength}
                    ></input>
                    <label
                      htmlFor="quadrantsTitle"
                      className={
                        overMaxMainTitleLength ? "character-count-error" : ""
                      }
                    >
                      Character count:{" "}
                      {afAreaTitle && afAreaTitle.length
                        ? afAreaTitle.length
                        : "0"}
                      /{maxMainTitleLength}
                    </label>
                  </div>
                </div>
              </div>

              <div className="edit-form-body-col">
                <div className="edit-form-thead subtitle-thead">
                  <div>
                    <p>Subtitle</p>
                  </div>
                </div>
                <div className="edit-form-input subtitle-input">
                  <div className="address-input-col">
                    <input
                      type="text"
                      id={`afAreaSubTitle`}
                      name={`afAreaSubTitle`}
                      className="title-input"
                      value={
                        afAreaSubTitle && afAreaSubTitle !== "-"
                          ? afAreaSubTitle
                          : ""
                      }
                      onChange={handleInputChange}
                      placeholder={
                        afAreaSubTitle && afAreaSubTitle !== "-"
                          ? afAreaSubTitle
                          : "Subtitle"
                      }
                      maxLength={maxMainSubtitleLength}
                    ></input>
                    <label
                      htmlFor="afAreaSubTitle"
                      className={
                        overMaxMainSubtitleLength ? "character-count-error" : ""
                      }
                    >
                      Character count:{" "}
                      {afAreaSubTitle &&
                      afAreaSubTitle !== "-" &&
                      afAreaSubTitle.length
                        ? afAreaSubTitle.length
                        : "0"}
                      /{maxMainSubtitleLength}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="edit-form-button-container">
            <div className="button-col">
              <div className="edit-form-cancel-button" onClick={onCloseFn}>
                <p>Close</p>
              </div>
            </div>
            <div className="button-col">
              <div
                className="edit-form-submit-button"
                onClick={onEditFormSubmit}
              >
                <p>Save</p>
              </div>
            </div>
          </div>
          {savingMessageShowing && (
            <div className="saving-message">Your work has been saved!</div>
          )}
        </div>
      </Fragment>
    );
  } else {
    let quadrantTitle =
      editQuadrantFormData[`af${selectedQuadrantNumber}Title`];
    let quadrantSubTitle =
      editQuadrantFormData[`af${selectedQuadrantNumber}SubTitle`];
    let quadrantText = editQuadrantFormData[`af${selectedQuadrantNumber}Text`];

    // let quadrantText = editQuadrantFormData[selectedQuadrantNumber].text;

    let maxQuadrantTextLength = 145;
    let overMaxQuadrantTextLength =
      quadrantText &&
      quadrantText.length &&
      quadrantText.length >= maxQuadrantTextLength;

    let maxQuadrantTitleLength = 11;
    let overMaxQuadrantTitleLength =
      quadrantTitle &&
      quadrantTitle.length &&
      quadrantTitle.length >= maxQuadrantTitleLength;
    let maxQuadrantSubTitleLength = 11;
    let overMaxQuadrantSubTitleLength =
      quadrantSubTitle &&
      quadrantSubTitle.length &&
      quadrantSubTitle.length >= maxQuadrantSubTitleLength;

    return (
      <Fragment>
        <div className="edit-quadrant-container">
          <div className="edit-quadrant-form new-props">
            <div className="edit-quadrant-form-title-container">
              <p className="edit-quadrant-form-title-text">
                You Can Make Changes to the Title, Subtitle, and Text Here
              </p>
            </div>
            <div className="edit-quadrant-form-body row-body">
              <div className="edit-form-body-col">
                <div className="edit-form-thead">
                  <div>
                    <p>Title</p>
                  </div>
                </div>
                <div className="edit-form-input">
                  <div className="address-input-col">
                    <input
                      type="text"
                      id={`af${selectedQuadrantNumber}Title`}
                      name={`af${selectedQuadrantNumber}Title`}
                      className="title-input"
                      value={quadrantTitle || ""}
                      onChange={handleInputChange}
                      placeholder={quadrantTitle}
                      maxLength={maxQuadrantTitleLength}
                    ></input>
                    <label
                      htmlFor={`af${selectedQuadrantNumber}Title`}
                      className={
                        overMaxQuadrantTitleLength
                          ? "character-count-error"
                          : ""
                      }
                    >
                      Character count:{" "}
                      {quadrantTitle && quadrantTitle.length
                        ? quadrantTitle.length
                        : "0"}
                      /{maxQuadrantTitleLength}
                    </label>
                  </div>
                </div>
              </div>

              <div className="edit-form-body-col">
                <div className="edit-form-thead">
                  <div>
                    <p>Subtitle</p>
                  </div>
                </div>
                <div className="edit-form-input">
                  <div className="address-input-col">
                    <input
                      type="text"
                      id={`af${selectedQuadrantNumber}SubTitle`}
                      name={`af${selectedQuadrantNumber}SubTitle`}
                      className="title-input"
                      value={quadrantSubTitle || ""}
                      onChange={handleInputChange}
                      placeholder={quadrantSubTitle}
                      maxLength={maxQuadrantSubTitleLength}
                    ></input>
                    <label
                      htmlFor={`af${selectedQuadrantNumber}SubTitle`}
                      className={
                        overMaxQuadrantSubTitleLength
                          ? "character-count-error"
                          : ""
                      }
                    >
                      Character count:{" "}
                      {quadrantSubTitle && quadrantSubTitle.length
                        ? quadrantSubTitle.length
                        : "0"}
                      /{maxQuadrantSubTitleLength}
                    </label>
                  </div>
                </div>
              </div>

              <div className="edit-form-body-col">
                <div className="edit-form-thead">
                  <div>
                    <p>Text</p>
                  </div>
                </div>
                <div className="edit-form-input">
                  <div className="address-input-col">
                    <textarea
                      placeholder={quadrantText}
                      onChange={handleInputChange}
                      name={`af${selectedQuadrantNumber}Text`}
                      value={quadrantText || ""}
                      className="quadrant-textarea"
                      maxLength={maxQuadrantTextLength}
                    ></textarea>

                    <label
                      htmlFor={`af${selectedQuadrantNumber}Text`}
                      className={
                        overMaxQuadrantTextLength ? "character-count-error" : ""
                      }
                    >
                      Character count:{" "}
                      {quadrantText && quadrantText.length
                        ? quadrantText.length
                        : "0"}
                      /{maxQuadrantTextLength}
                    </label>
                    {/*<input
                    type="textbox"
                    id={`text-${selectedQuadrantNumber}`}
                    name={`text-${selectedQuadrantNumber}`}
                    value={
                      editQuadrantFormData[selectedQuadrantNumber].text || ""
                    }
                    onChange={handleInputChange}
                    placeholder={(e) =>
                      editQuadrantFormData[selectedQuadrantNumber].text(
                        e,
                        "text"
                      )
                    }
                  ></input>*/}
                    {/*<input
                    type="textbox"
                    id={`text-${selectedQuadrantNumber}`}
                    name={`text-${selectedQuadrantNumber}`}
                    value={
                      editQuadrantFormData[selectedQuadrantNumber].text || ""
                    }
                    onChange={handleInputChange}
                    placeholder={(e) =>
                      editQuadrantFormData[selectedQuadrantNumber].text(
                        e,
                        "text"
                      )
                    }
                  ></input>*/}
                    {/*<input
                    type="textbox"
                    id={`text-${selectedQuadrantNumber}`}
                    name={`text-${selectedQuadrantNumber}`}
                    value={
                      editQuadrantFormData[selectedQuadrantNumber].text || ""
                    }
                    onChange={handleInputChange}
                    placeholder={(e) =>
                      editQuadrantFormData[selectedQuadrantNumber].text(
                        e,
                        "text"
                      )
                    }
                  ></input>*/}
                    {/*<input
                    type="textbox"
                    id={`text-${selectedQuadrantNumber}`}
                    name={`text-${selectedQuadrantNumber}`}
                    value={
                      editQuadrantFormData[selectedQuadrantNumber].text || ""
                    }
                    onChange={handleInputChange}
                    placeholder={(e) =>
                      editQuadrantFormData[selectedQuadrantNumber].text(
                        e,
                        "text"
                      )
                    }
                  ></input>*/}
                    {/*<input
                    type="textbox"
                    id={`text-${selectedQuadrantNumber}`}
                    name={`text-${selectedQuadrantNumber}`}
                    value={
                      editQuadrantFormData[selectedQuadrantNumber].text || ""
                    }
                    onChange={handleInputChange}
                    placeholder={(e) =>
                      editQuadrantFormData[selectedQuadrantNumber].text(
                        e,
                        "text"
                      )
                    }
                  ></input>*/}
                  </div>
                </div>
                {/*<div className="edit-form-body-col">
                <textarea
                  // name="textarea"
                  style={{ width: "250px", height: "150px" }}
                  placeholder={
                    editQuadrantFormData[selectedQuadrantNumber].text
                  }
                  onChange={handleInputChange}
                  name={`text-${selectedQuadrantNumber}`}
                  value={
                    editQuadrantFormData[selectedQuadrantNumber].text || ""
                  }
                  className="quadrant-textarea"
                ></textarea>
              </div>*/}
              </div>
            </div>
          </div>

          <div className="edit-form-button-container">
            <div className="button-col">
              <div className="edit-form-cancel-button" onClick={onCloseFn}>
                <p>Close</p>
              </div>
              {/*<div className="restore-default" onClick={handleRestoreDefault}>
                <p>Restore Default</p>
              </div>*/}
            </div>
            <div className="button-col">
              <div
                className="edit-form-submit-button"
                onClick={onEditFormSubmit}
              >
                <p>Save</p>
              </div>
            </div>
          </div>
          {savingMessageShowing && (
            <div className="saving-message">Your work has been saved!</div>
          )}
        </div>
        {/*</Dialog>*/}
      </Fragment>
    );
  }
};

export default compose(withSnackbar)(EditQuadrantModal);
